/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

/**
 * Getting entire users state into the component
 */
const selectDomain = (state) => state['feature/llm'] || initialState;

export const selectCreatedModel = createSelector([selectDomain], (llmState) => llmState.createdModel);
/**
 * Getting the loader state into the component
 */
export const selectLoader = createSelector([selectDomain], (llmState) => llmState.loading);

export const selectAllModels = createSelector(
  [selectDomain],
  (llmState) => llmState.allModels
);

/**
 * Getting LLM default models state into LLM component
 */
export const selectLlmDefaultModels = createSelector(
  [selectDomain],
  (llmState) => llmState.llmDefaultModels
);

export const selectModelUsage = createSelector([selectDomain], (llmState) => llmState.modelUsage);
export const selectLlmLogs = createSelector([selectDomain], (llmState) => llmState.llmLogs);
export const selectUsageLoader = createSelector([selectDomain], (llmState) => llmState.usageLoading);
export const selectLogsLoader = createSelector([selectDomain], (llmState) => llmState.logsLoading);
export const selectChartLogs = createSelector([selectDomain], (llmState) => llmState.chartLogs);

